import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import React from 'react'

import { Theme, useMediaQuery } from '@mui/material'

import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import GetMatched from 'app/features/Profile/MatchMeFeature/GetMatched'
import InitialFilterControl from 'app/features/SearchFeature/components/InitialFilterControl'
import SearchAppProvider, {
  DISJUNCTIVE_FACETS,
  FACETS,
  RESULT_FIELDS,
  SEARCH_FIELDS
} from 'app/features/SearchFeature/providers/SearchProvider'
import SearchAppResult from 'app/features/SearchFeature/SearchResult'

import FilterPanel from './FilterPanel'
import HomeViewContainer from './HomeViewContainer'

const BoxLicenseInformation = dynamic(
  () => import('~/views/HomeView/components/BoxLicenseInformation'),
  {
    ssr: false
  }
)

const SearchPagination = dynamic(
  () => import('app/features/SearchFeature/components/SearchPagination'),
  {
    ssr: false
  }
)

const ActiveFilters = dynamic(
  () => import('app/features/HomePageFeature/ChipFeature/ActiveFilters')
)

const SearchSection = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const router = useRouter()
  const partRequest = router.query.partRequest as string

  return (
    <SearchAppProvider
      searchQuery={{
        facets: FACETS,
        disjunctiveFacets: DISJUNCTIVE_FACETS,
        search_fields: SEARCH_FIELDS,
        result_fields: RESULT_FIELDS
      }}
    >
      <Stack sx={{ overflowX: 'hidden' }}>
        <Box
          sx={{
            ...(!isMobile && { boxShadow: '0px 12px 24px -4px #919EAB26' }),
            mb: { xs: 2, md: 2.25 }
          }}
        >
          <HomeViewContainer>
            <InitialFilterControl />

            <FilterPanel />
          </HomeViewContainer>
        </Box>

        <Stack spacing={2} sx={{ display: { md: 'none' } }}>
          {isMobile && <ActiveFilters />}

          <HomeViewContainer>
            <BoxLicenseInformation />
          </HomeViewContainer>
        </Stack>

        <HomeViewContainer>
          <Stack spacing={{ xs: 3.75, sm: 5 }}>
            {partRequest && <GetMatched defaultShowForm />}

            {!partRequest && (
              <>
                <SearchAppResult />

                <SearchPagination />
              </>
            )}
          </Stack>
        </HomeViewContainer>
      </Stack>
    </SearchAppProvider>
  )
}

export default SearchSection
